<template>
  <div>
    <h2 v-if="tasteKind">{{ tasteKind.TasteKindName }}</h2>
    <div class="row">
      <div class="col-lg-5">
        <h5>{{ $t("title.unselectedkind") }}</h5>
        <div class="card card-table">
          <div class="card-header">
            <button
              type="button"
              class="btn btn-outline-primary btn-icon"
              @click="onAdd"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>

          <div class="card-body card-table-body">
            <div class="form-group row">
              <label for="notMin" class="col-3 col-sm-2 col-form-label"
                >{{ $t("modal.min") }}:</label
              >
              <div class="col-3 col-sm-4">
                <input
                  id="notMin"
                  type="number"
                  class="form-control"
                  v-model="notMin"
                />
              </div>
              <label for="notMax" class="col-3 col-sm-2 col-form-label"
                >{{ $t("modal.max") }}:</label
              >
              <div class="col-3 col-sm-4">
                <input
                  id="notMax"
                  type="number"
                  class="form-control"
                  v-model="notMax"
                />
              </div>
            </div>
            <div class="table-responsive custom-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div class="custom-control custom-checkbox mr-sm-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="allAdd"
                          v-model="allAdd"
                        />
                        <label class="custom-control-label" for="allAdd">{{
                          $t("columnName.alladd")
                        }}</label>
                      </div>
                    </th>
                    <th>{{ $t("columnName.foodkindnumber") }}</th>
                    <th>{{ $t("columnName.foodkindname") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="notSelected in notSelecteds"
                    :key="notSelected.FoodKindId"
                    @click="notSelectedClick(notSelected.FoodKindId)"
                  >
                    <td>
                      <input
                        class="checkbox"
                        type="checkbox"
                        :value="notSelected.FoodKindId"
                        v-model="addIds"
                      />
                    </td>
                    <td>{{ notSelected.FoodKindNumber }}</td>
                    <td>{{ notSelected.FoodKindName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <h5>{{ $t("title.selectedkind") }}</h5>
        <div class="card card-table">
          <div class="card-header">
            <button
              type="button"
              class="btn btn-outline-success btn-icon"
              @click="onEdit"
            >
              <i class="fas fa-pen"></i>
            </button>
            <button
              type="button"
              class="btn btn-outline-danger btn-icon"
              @click="onRemove"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
          <div class="card-body card-table-body">
            <div class="form-group row">
              <label for="min" class="col-3 col-sm-2 col-form-label"
                >{{ $t("modal.min") }}:</label
              >
              <div class="col-3 col-sm-4">
                <input
                  id="min"
                  type="number"
                  class="form-control"
                  v-model="min"
                />
              </div>
              <label for="max" class="col-3 col-sm-2 col-form-label"
                >{{ $t("modal.max") }}:</label
              >
              <div class="col-3 col-sm-4">
                <input
                  id="max"
                  type="number"
                  class="form-control"
                  v-model="max"
                />
              </div>
            </div>
            <div class="table-responsive custom-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div class="custom-control custom-checkbox mr-sm-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="allRemove"
                          v-model="allRemove"
                        />
                        <label class="custom-control-label" for="allRemove">{{
                          $t("columnName.alladd")
                        }}</label>
                      </div>
                    </th>
                    <th>{{ $t("columnName.foodkindnumber") }}</th>
                    <th>{{ $t("columnName.foodkindname") }}</th>
                    <th>{{ $t("columnName.min") }}</th>
                    <th>{{ $t("columnName.max") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="selected in selecteds"
                    :key="selected.FoodKindId"
                    @click="selectedClick(selected.FoodKindId)"
                  >
                    <td>
                      <input
                        class="checkbox"
                        type="checkbox"
                        :value="selected.FoodKindId"
                        v-model="removeIds"
                      />
                    </td>
                    <td>{{ selected.FoodKindNumber }}</td>
                    <td>{{ selected.FoodKindName }}</td>
                    <td>{{ selected.MinQty }}</td>
                    <td>{{ selected.MaxQty }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tasteKind: {},
      notSelecteds: [],
      notMin: 0,
      notMax: 0,
      selecteds: [],
      min: 0,
      max: 0,
      addIds: [],
      removeIds: [],
      allAdd: false,
      allRemove: false,
    };
  },
  props: ["isShow"],
  watch: {
    allAdd(value) {
      this.addIds = [];
      if (value) {
        this.notSelecteds.forEach((item) => this.addIds.push(item.FoodKindId));
      }
    },
    allRemove(value) {
      this.removeIds = [];
      if (value) {
        this.selecteds.forEach((item) => this.removeIds.push(item.FoodKindId));
      }
    },
  },
  methods: {
    notSelectedClick(id) {
      const index = this.addIds.indexOf(id);
      if (index >= 0) {
        this.addIds.splice(index, 1);
      } else {
        this.addIds.push(id);
      }
    },
    selectedClick(id) {
      const index = this.removeIds.indexOf(id);
      if (index >= 0) {
        this.removeIds.splice(index, 1);
      } else {
        this.removeIds.push(id);
      }
    },
    updateFoodKinds() {
      const vm = this;
      this.$api.foodKindTastes
        .getFoodKinds(vm.tasteKind.TasteKindId)
        .then((data) => {
          vm.addIds = [];
          vm.removeIds = [];
          vm.notSelecteds = data.NotSelecteds;
          vm.selecteds = data.Selecteds;
          vm.allAdd = false;
          vm.allRemove = false;
        });
    },
    onAdd() {
      if (this.addIds.length == 0) {
        this.$func.message.alert("請選擇類別 !");
        return;
      }
      if (this.notMax != 0 && this.notMin > this.notMax) {
        this.$func.message.alert("數量輸入錯誤 !");
        return;
      }
      const vm = this;
      this.$api.foodKindTastes
        .postFoodKinds({
          TasteKindId: vm.tasteKind.TasteKindId,
          FoodKindIds: vm.addIds,
          MinQty: vm.notMin,
          MaxQty: vm.notMax,
        })
        .then(() => {
          vm.updateFoodKinds();
          vm.notMin = 0;
          vm.notMax = 0;
        });
    },
    onEdit() {
      if (this.removeIds.length == 0) {
        this.$func.message.alert("請選擇類別 !");
        return;
      }
      if (this.max != 0 && this.min > this.max) {
        this.$func.message.alert("數量輸入錯誤 !");
        return;
      }
      const vm = this;
      this.$api.foodKindTastes
        .postFoodKinds({
          TasteKindId: vm.tasteKind.TasteKindId,
          FoodKindIds: vm.removeIds,
          MinQty: vm.min,
          MaxQty: vm.max,
        })
        .then(() => {
          vm.updateFoodKinds();
          vm.min = 0;
          vm.max = 0;
        });
    },
    onRemove() {
      if (this.removeIds.length == 0) {
        this.$func.message.alert("請選擇類別 !");
        return;
      }
      const vm = this;
      this.$api.foodKindTastes
        .removeFoodKinds({
          TasteKindId: vm.tasteKind.TasteKindId,
          FoodKindIds: vm.removeIds,
        })
        .then(() => vm.updateFoodKinds());
    },
    addFoodKinds(items) {
      const vm = this;
      items.forEach(function (item) {
        vm.notSelecteds.push(item);
        vm.addIds.push(item.FoodKindId);
      });
    },
  },
  created() {
    const vm = this;
    this.$api.tasteKinds.get(vm.$route.params.id).then((data) => {
      vm.tasteKind = data;
      this.updateFoodKinds();
    });
  },
};
</script>
